import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import historyUtils from "../../libs/history.utils";
import { useDispatch, useSelector } from "react-redux";
import { serviceGetHierarchy, serviceGetHierarchyExport } from "../../services/HierarchyReport.service";
import { updateHierarchyReport } from "../../actions/HierarchyForm.action";

const totalShow = 50;
const useHierarchyReport = ({}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloading, setDownloading] = useState(false);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [inActiveData, setInActiveData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const dispatch = useDispatch();
  const form = useSelector((state) => state.hierarchy_report);

  useEffect(() => {
    if (form?.fy_year && form?.month && form?.quarter) {
      resetData();
    }
  }, [form]);

  const resetData = useCallback(() => {
    setIsSubmitting(true);
    const commonPayload = {
      ...form,
    };

    Promise.allSettled([
      serviceGetHierarchy({ ...commonPayload, status: "ACTIVE" }),
    ])
      .then(([activeRes]) => {
        if (activeRes.status === "fulfilled" && !activeRes.value?.error) {
          setCurrentData(activeRes.value.data || []);
        } else {
          console.error(
            "Error in ACTIVE API",
            activeRes.reason || activeRes.value?.error
          );
          setCurrentData([]);
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }, [setIsSubmitting, form]);

  const handleViewDetails = useCallback((data) => {
    historyUtils.push(`/employees/details/${data?.emp_code}`);
  }, []);

  console.log("form", form);
  const changeTextData = useCallback(
    (text, fieldName) => {
      const updatedForm = { ...form };

      if (fieldName === "fy_year") {
        updatedForm[fieldName] = text;
      } else if (fieldName === "quarter") {
        updatedForm[fieldName] = text;
        updatedForm["month"] = "";
      } else {
        updatedForm[fieldName] = text;
      }

      dispatch(updateHierarchyReport(updatedForm));
    },
    [form, dispatch]
  );

   const handleDownload = useCallback(() => {
      if (form?.fy_year && form?.month && form?.quarter) {
        setDownloading(true);
        serviceGetHierarchyExport({
          ...form,
        }).then((res) => {
          if (!res?.error) {
            const data = res?.data;
            window.open(data, "_blank");
          }
          setDownloading(false);
        });
      }
    }, [form, setDownloading]);

  return {
    currentData,
    data: apiData,
    currentPage,
    handleViewDetails,
    isSubmitting,
    form,
    changeTextData,
    inActiveData,
    handleDownload,
    downloading
  };
};

export default useHierarchyReport;
